import axios from 'axios';

const baseURL = (window.location.hostname.endsWith('.sites-dev.attendzen.io') || (window.parent.location.hostname == 'platform-dev.attendzen.io') || (window.parent.location.hostname == 'localhost')) ? 'https://api-dev.attendzen.io/' : 'https://api.attendzen.io/';

// console.log({baseURL});

const prelude = axios.create({
	baseURL: baseURL,
	timeout: 100000,
	withCredentials: false
});

export const getServerData = async (endpoint, params) => {

	try {

		const response = await prelude({
			url: endpoint,
			method: "GET",
			params: params
		});

		return response.data;

	} catch (err) {

		return null;

	}

}

export const postServerData = async (endpoint, params) => {

	let formData = new FormData();

	if (params) {
		for (let [key, value] of Object.entries(params)) {
			formData.append(key, value);
		}
	}

	try {

		const response = await prelude({
			url: endpoint,
			method: "POST",
			data: formData
		});

		return response.data;

	} catch (err) {

		// console.log(err.toJSON());
		// console.log(err.response.status);

		return null;

	}

}